// Store-owned market domains may be absent from Shopify's preview hreflang links.
export const storeMarketHosts = [
  'punkt-malerei-de.myshopify.com',
  'paintbydots.co',
  'prikmaleri.dk',
  'prickmalning.se',
  'punkt-malerei.de',
  'dotpainting.co.uk',
];

export function previewNavigationUrl(href, context) {
  if (!href || href.trim().startsWith('#')) return null;
  let url;
  try { url = new URL(href.trim(), context.origin); } catch { return null; }
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
  if (!context.hosts.includes(url.hostname)) return null;
  const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
  if (!/^\/(?:$|products(?:\/|$)|collections(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|policies(?:\/|$)|search\/?$|cart\/?$)/.test(path)) return null;
  if (url.searchParams.has('preview_theme_id') && url.searchParams.get('preview_theme_id') !== context.themeId) return null;
  url.protocol = new URL(context.origin).protocol;
  url.host = new URL(context.origin).host;
  url.searchParams.set('preview_theme_id', context.themeId);
  url.searchParams.set('_fd', '0');
  url.searchParams.set('pb', '0');
  if (path === '/products/custom-photo-dot-painting-kit' && !url.searchParams.has('view')) {
    url.searchParams.set('view', 'photo-studio-v4');
  }
  return url.href;
}

if (typeof document !== 'undefined') {
  const config = document.querySelector('[data-pbd-preview-navigation]');
  if (config && window.Shopify?.theme?.role === 'unpublished') {
    const hosts = new Set([...storeMarketHosts, location.hostname, config.dataset.shopHost, config.dataset.primaryHost]);
    document.querySelectorAll('link[rel="alternate"][hreflang][href]').forEach(link => {
      try { hosts.add(new URL(link.href).hostname); } catch {}
    });
    const context = { origin: location.origin, themeId: config.dataset.themeId, hosts: [...hosts] };
    const updateLink = link => {
      if (link.closest('localization-form') || link.hasAttribute('download') || link.hasAttribute('hreflang')) return;
      const url = previewNavigationUrl(link.getAttribute('href'), context);
      if (url && link.href !== url) link.setAttribute('href', url);
    };
    const updateTree = node => {
      if (node.nodeType !== 1) return;
      if (node.matches('a[href]')) updateLink(node);
      node.querySelectorAll('a[href]').forEach(updateLink);
    };
    updateTree(document.documentElement);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') updateLink(record.target);
      else record.addedNodes.forEach(updateTree);
    })).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      if (link) updateLink(link);
    }, true);
    document.querySelectorAll('form[method="get" i]').forEach(form => {
      const url = previewNavigationUrl(form.getAttribute('action'), context);
      if (!url) return;
      form.action = new URL(url).pathname;
      for (const [name, value] of [['preview_theme_id', context.themeId], ['_fd', '0'], ['pb', '0']]) {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
        input.value = value;
      }
    });
  }
}
